"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        id: "0",
        name: "NOT APPLICABLE"
    },
    {
        id: "1",
        name: "BIOLOGY"
    },
    {
        id: "2",
        name: "CHEMISTRY"
    },
    {
        id: "3",
        name: "PHYSICS"
    },
    {
        id: "5",
        name: "EARTH SCIENCE"
    },
    {
        id: "6",
        name: "PHYSICAL SCIENCE"
    },
    {
        id: "8",
        name: "GENERAL SCIENCE"
    },
    {
        id: "9",
        name: "SCIENCE"
    },
    {
        id: "10",
        name: "MATHEMATICS"
    },
    {
        id: "11",
        name: "ARABIC"
    },
    {
        id: "12",
        name: "JAPANESE"
    },
    {
        id: "13",
        name: "AMERICAN SIGN LANGUAGE"
    },
    {
        id: "15",
        name: "MUSIC"
    },
    {
        id: "16",
        name: "ROTC"
    },
    {
        id: "17",
        name: "DRIVER EDUCATION"
    },
    {
        id: "20",
        name: "ENGLISH AS A SECOND LANGUAGE"
    },
    {
        id: "22",
        name: "ENGLISH"
    },
    {
        id: "23",
        name: "JOURNALISM"
    },
    {
        id: "24",
        name: "SPEECH"
    },
    {
        id: "25",
        name: "THEATRE ARTS"
    },
    {
        id: "27",
        name: "READING"
    },
    {
        id: "31",
        name: "ECONOMICS"
    },
    {
        id: "32",
        name: "GEOGRAPHY"
    },
    {
        id: "33",
        name: "GOVERNMENT/POLITICAL SCIENCE"
    },
    {
        id: "34",
        name: "HISTORY"
    },
    {
        id: "35",
        name: "PSYCHOLOGY"
    },
    {
        id: "36",
        name: "ADVANCED SOCIAL SCIENCE"
    },
    {
        id: "37",
        name: "SOCIOLOGY"
    },
    {
        id: "38",
        name: "SOCIAL STUDIES"
    },
    {
        id: "40",
        name: "ITALIAN"
    },
    {
        id: "41",
        name: "FRENCH"
    },
    {
        id: "42",
        name: "GERMAN"
    },
    {
        id: "43",
        name: "LATIN"
    },
    {
        id: "44",
        name: "SPANISH"
    },
    {
        id: "45",
        name: "RUSSIAN"
    },
    {
        id: "47",
        name: "PORTUGUESE"
    },
    {
        id: "48",
        name: "HEBREW"
    },
    {
        id: "49",
        name: "CHINESE"
    },
    {
        id: "50",
        name: "ART"
    },
    {
        id: "51",
        name: "VIETNAMESE"
    },
    {
        id: "52",
        name: "HINDI"
    },
    {
        id: "58",
        name: "COMPUTER SCIENCE"
    },
    {
        id: "63",
        name: "AGRICULTURAL SCIENCE & TECH ED"
    },
    {
        id: "68",
        name: "HEALTH SCIENCE TECHNOLOGY"
    },
    {
        id: "69",
        name: "TECHNOLOGY EDUCATION"
    },
    {
        id: "71",
        name: "DESKTOP PUBLISHING"
    },
    {
        id: "72",
        name: "DIGITAL GRAPHICS/ANIMATION"
    },
    {
        id: "73",
        name: "MULTIMEDIA"
    },
    {
        id: "74",
        name: "VIDEO TECHNOLOGY"
    },
    {
        id: "75",
        name: "WEB MASTERING"
    },
    {
        id: "76",
        name: "AGRICUL, FOOD, & NAT RESOURCES"
    },
    {
        id: "77",
        name: "ARCHITECTURE & CONSTRUCTION"
    },
    {
        id: "78",
        name: "ARTS, A/V TECH, & COMM"
    },
    {
        id: "79",
        name: "BUSINESS MANAGEMENT & ADMIN"
    },
    {
        id: "80",
        name: "EDUCATION & TRAINING"
    },
    {
        id: "81",
        name: "HEALTH"
    },
    {
        id: "82",
        name: "PHYSICAL EDUCATION"
    },
    {
        id: "83",
        name: "DANCE"
    },
    {
        id: "84",
        name: "FINANCE"
    },
    {
        id: "85",
        name: "GOVERNMENT & PUBLIC ADMIN"
    },
    {
        id: "86",
        name: "HEALTH SCIENCE"
    },
    {
        id: "87",
        name: "HOSPITALITY & TOURISM"
    },
    {
        id: "88",
        name: "HUMAN SERVICES"
    },
    {
        id: "89",
        name: "INFORMATION TECHNOLOGY"
    },
    {
        id: "91",
        name: "LAW, PUBLIC SAFE, CORR, & SEC"
    },
    {
        id: "92",
        name: "MANUFACTURING"
    },
    {
        id: "93",
        name: "MARKETING"
    },
    {
        id: "94",
        name: "SCIENCE, TECH, ENG, & MATH"
    },
    {
        id: "95",
        name: "TRANS, DIST, & LOG"
    },
    {
        id: "96",
        name: "CAREER DEVELOPMENT"
    },
    {
        id: "98",
        name: "GENERIC"
    },
    {
        id: "99",
        name: "OTHER"
    }
];
//# sourceMappingURL=subjects.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/subjects_data/subjects.js
// module id = 457
// module chunks = 22